<template>
		<div class="login_page">
        <el-form
          autoComplete="on"
          :model="loginForm"
          :rules="loginRules"
          ref="loginForm"
          label-position="left"
          label-width="0px"
          class="card-box login-form"
        >
          <div class="the_head">
            <h3 class="title">KT客服中心</h3>
          </div>
          <el-form-item prop="loginName">
            <span class="svg-container svg-container_login">
              <i class="iconfont el-icon-dt-usered"></i>
            </span>
            <el-input
              name="loginName2"
              type="text"
              v-model.trim="loginForm.loginName"
              autoComplete="on"
              placeholder="请输入用户名"
			  @click="clearMsg()"
            />
          </el-form-item>
          <el-form-item prop="password">
            <span class="svg-container">
              <i class="iconfont el-icon-dt-jinyong"></i>
            </span>
            <el-input
              name="password2"
              :type="pwdType"
              @keyup.enter.native="login"
              v-model.trim="loginForm.password"
              autoComplete="on"
              placeholder="请输入密码"
			  @click="clearMsg()"
            ></el-input>
            <span class="show-pwd" @click="showPwd">
            </span>
          </el-form-item>
		  
          <!-- 
		  <el-form-item prop="imgCode">
	      <span class="svg-container">
	        <img src="../assets/img/verification _code.png" height="20" width="20">
	      </span>
	      <el-input name="imgCode" type="text" autoComplete="on" v-model.trim="imgCode" placeholder="请输入图形验证码" /></el-input>
	      <span class="show-pwd imgCode">
	         <img :src="imgCodeUrl" @click="refreshImgCode"/>
	      </span>
	    </el-form-item>
		 -->
		 
          <!-- <el-form-item prop="captcha">
	       <span class="svg-container">
	        <img src="../assets/img/security_code.png" height="20" width="20">
	      </span>
	      <el-input name="captcha" type="text" @keyup.enter.native="handleLogin" v-model.trim="loginForm.captcha" autoComplete="on" placeholder="请输入短信验证码" /></el-input>
	      <el-button class="send-button"  type="primary" @click="send" style=";height:52px background: pink;">
	        <span v-if="sendMsgDisabled">{{time+'s'}}</span>
	        <span v-if="!sendMsgDisabled">获取验证码</span>
	      </el-button>
	    </el-form-item>
		 -->
		 
		<div class="the_head" style="color:red;margin:10px;">
		  {{msg}}
		</div>
		
          <el-form-item>
            <el-button
              type="primary"
              style="width: 100%"
              :loading="loading"
              @click="login"
            >
              登录
            </el-button>
          </el-form-item>
		  <div style="margin:15px;"><a href="#/register">受邀注册</a></div>
        </el-form>
		 
		</div>
</template>

<script>
import { Card } from "@/components/index";
import Cookies from "js-cookie";
export default {
  data() {
    return {
      loginForm: {
        loginName: "",
        password: "",
        captcha: "",
      },
      loginRules: {
        loginName: [
          { required: true, message: "用户名不能为空", trigger: "blur" },
        ],
        password: [
          { required: true, message: "密码不能为空", trigger: "blur" },
        ],
      },
      loading: false,
      pwdType: "password",
      timeStamp: "",
      imgCodeUrl: "",
      imgCode: "",
      time: 60,
      sendMsgDisabled: false,
      lock: false,
	  msg:"",
    };
  },
  created() {},
  methods: {
    showPwd() {
      if (this.pwdType === "password") {
        this.pwdType = "";
      } else {
        this.pwdType = "password";
      }
    },
    async login() {		
		let params={
		  user: {
		    loginName: this.loginForm.loginName,
		    password:this.loginForm.password,
		  },
		  captcha:this.loginForm.captcha,
		};
		
		let res =await this.$axios.post(this.$serverUrl+"/login",params);

		if(res.data.status!=1){
			this.msg=res.data.msg;
		}else{
		
	    let user=res.data.data

		this.loading = false;
		if (user && user.length > 0) {
		  //sessionStorage.setItem("loginStatus", res.status);
		  //let nickName = user[0].nickName;
		  sessionStorage.setItem("loginName", user[0].loginName);
		  //sessionStorage.setItem("userName",user[0].name);
		  //sessionStorage.setItem("userId", user[0].id);
		  sessionStorage.setItem("userMenu", JSON.stringify(user[1]));
		  //sessionStorage.setItem("email",user[0].email);
		  sessionStorage.setItem("token",user[0].token);
		  //localStorage.setItem('isLoggedIn', true);
		  this.$router.push('/user');
		  }		  
		}
    },
	clearMsg(){
		this.msg="";
	}
  },
};
</script>
<style>
</style>